import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '@/lib/firebase';

export async function uploadFile(file: File, path: string): Promise<string> {
  try {
    const storageRef = ref(storage, path);
    // Explicitly pass contentType so Firebase Storage security rules always see
    // the correct MIME type (e.g. image/gif, image/jpeg). Without this, some
    // runtimes/SDKs default to application/octet-stream, which fails rules that
    // check request.resource.contentType.matches('image/.*').
    const metadata = file.type ? { contentType: file.type } : undefined;
    const snapshot = await uploadBytes(storageRef, file, metadata);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
}

export async function deleteFile(path: string): Promise<void> {
  try {
    const storageRef = ref(storage, path);
    await deleteObject(storageRef);
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
}

export function getStoragePath(type: 'theme-image' | 'theme-video' | 'font', userId: string, fileName: string): string {
  switch (type) {
    case 'theme-image':
      return `theme-assets/images/${userId}/${fileName}`;
    case 'theme-video':
      return `theme-assets/videos/${userId}/${fileName}`;
    case 'font':
      return `fonts/${userId}/${fileName}`;
    default:
      throw new Error(`Unknown storage type: ${type}`);
  }
}
